import { render, staticRenderFns } from "./Podcast.vue?vue&type=template&id=23b283a0&scoped=true"
import script from "./Podcast.vue?vue&type=script&lang=js"
export * from "./Podcast.vue?vue&type=script&lang=js"
import style0 from "./Podcast.vue?vue&type=style&index=0&id=23b283a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b283a0",
  null
  
)

export default component.exports